import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "q-row q-px-5 q-mb-2 q-bg-white get-the-look__gtl-container" }
const _hoisted_3 = {
  key: 0,
  class: "q-px-5 q-mb-2 q-bg-white get-the-looks__price-container q-d-flex"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "get-the-look__total-text" }, /*#__PURE__*/_toDisplayString('Wartość wybranej stylizacji: '), -1)
const _hoisted_5 = { class: "get-the-look__total-prices" }
const _hoisted_6 = {
  key: 0,
  class: "get-the-look__tot-price-old"
}
const _hoisted_7 = {
  key: 0,
  class: "stylisation__total-discount"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "stylisation__total-discount-text" }, "Rabat:", -1)
const _hoisted_9 = { class: "stylisation__discount" }

import {onMounted, ref, PropType, computed, watch} from 'vue'
import ComponentLoader from './ComponentLoader.vue'
import {Navigation, Pagination} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import GetTheLook from '@/components/GetTheLook/GetTheLook.vue'
import {storeToRefs} from 'pinia'
import {useGetTheLookStore} from '@/store/getTheLookStore'
import GetTheLookHeader from '@/components/GetTheLook/GetTheLookHeader.vue'
import SeeMoreButton from "@/components/SeeMoreButton.vue";
import {formatPrice, getDiscount, parsePrice} from "@/core/utils";
import {useStylisationStore} from "@/store/stylisationStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'GetTheLooksCategorized',
  props: {
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  setup(__props) {

const props = __props;




const modules = ref([Pagination, Navigation])

const getTheLookStore = useGetTheLookStore()
const stylizationStore = useStylisationStore()
const {stylisationId} = storeToRefs(stylizationStore)

const {
  getTheLooksCategorized,
  getGetTheLooksWithoutFirst,
  getGetTheLookLoading,
  hasGetTheLooks
} = storeToRefs(getTheLookStore)

const GetTheLooks = computed(() => {
  return props.useAsSeparate ? getGetTheLooksWithoutFirst.value : getTheLooksCategorized.value
})

const stylisationStore = useStylisationStore()

const {hasStylisation} = storeToRefs(stylisationStore)

const totalValue = ref(0);
const totalOldValue = ref(0);
const activeProducts = ref([] as Array<object>)

const discount = ref<number | null>(0);


function updateActiveStylization(swiper, changedStylisation: number) {

  const activeProductIndex = swiper.activeIndex;
  const activeStylization = GetTheLooks.value[changedStylisation];

  activeProducts.value[changedStylisation] = activeStylization.products[activeProductIndex]
  calculateSumOfActiveProducts()
  calculateOldSumOfActiveProducts()
  calculateTotalDiscount()
}


const calculateSumOfActiveProducts = () => {

  totalValue.value = activeProducts.value.reduce((sum, product) => {

    if (!product || typeof product.variants === 'undefined') {
      return 0
    }
    const price = product.price
    const firstVariant = product.variants[0]
    const salePrice = firstVariant.sale_price || firstVariant.old_price

    const actualPrice = salePrice ? salePrice : price

    const priceNumber = parsePrice(actualPrice)?.toFixed(2)


    return (Number(sum) + Number(priceNumber)).toFixed(2);
  }, 0)
}

const calculateOldSumOfActiveProducts = () => {
  totalOldValue.value = activeProducts.value.reduce((sum, product) => {
    if (!product || typeof product.variants === 'undefined') {
      return 0
    }
    const price = product.price
    const firstVariant = product.variants[0]
    const salePrice = firstVariant.sale_price || firstVariant.old_price || product.price

    const oldPrice = salePrice ? price : salePrice

    const oldPriceNumber = parsePrice(oldPrice) || 0


    return (Number(sum) + Number(oldPriceNumber)).toFixed(2);
  }, 0)
}

const getInitialActiveProducts = () => {
  if (!hasGetTheLooks.value) {
    return
  }

  activeProducts.value = GetTheLooks?.value.map(element => {
    return element.products[0]
  })


}

const calculateTotalDiscount = () => {
  discount.value = getDiscount(totalValue.value, totalOldValue.value)
}


onMounted(async () => {
  await getTheLookStore.fetchGetTheLooksCategorized()
  getInitialActiveProducts()
  calculateSumOfActiveProducts()
  calculateOldSumOfActiveProducts()
  calculateTotalDiscount()
})
watch(stylisationId, () => {

  getInitialActiveProducts()
  calculateSumOfActiveProducts()
  calculateOldSumOfActiveProducts()
  calculateTotalDiscount()

}, {immediate: false});


return (_ctx: any,_cache: any) => {
  const _component_NoStylisationInfo = _resolveComponent("NoStylisationInfo")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(hasGetTheLooks))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ComponentLoader, { loading: _unref(getGetTheLookLoading) }, null, 8, ["loading"]),
          _createVNode(GetTheLookHeader, { "use-as-separate": __props.useAsSeparate }, null, 8, ["use-as-separate"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(GetTheLooks.value, (stylisationSet, stylisationIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: stylisationSet.categoryNumber
            }, [
              _createVNode(_unref(Swiper), {
                class: "swiper",
                navigation: true,
                modules: modules.value,
                "space-between": 30,
                "slides-per-view": 1,
                "centered-slides": false,
                pagination: { clickable: true },
                onSlideChange: event => updateActiveStylization(event,stylisationIndex)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stylisationSet.products, (product) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      class: "slide",
                      key: product.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(GetTheLook, {
                            product: product,
                            "use-as-separate": __props.useAsSeparate
                          }, null, 8, ["product", "use-as-separate"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modules", "onSlideChange"])
            ]))
          }), 128)),
          (totalValue.value !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("strong", {
                    class: _normalizeClass(["get-the-look__total-price", {'--promotion': discount.value }])
                  }, _toDisplayString(_unref(formatPrice)(totalValue.value)) + "  ", 3),
                  (totalOldValue.value && totalValue.value !== totalOldValue.value)
                    ? (_openBlock(), _createElementBlock("del", _hoisted_6, _toDisplayString(_unref(formatPrice)(totalOldValue.value)), 1))
                    : _createCommentVNode("", true)
                ]),
                (discount.value && totalValue.value !== totalOldValue.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("span", _hoisted_9, "-" + _toDisplayString(discount.value) + "%", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.useAsSeparate)
            ? (_openBlock(), _createBlock(SeeMoreButton, {
                key: 1,
                title: 'Zobacz inne stylizacje >'
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_NoStylisationInfo, {
      "show-alert": !_unref(getGetTheLookLoading) && _unref(hasStylisation) && !_unref(hasGetTheLooks)
    }, null, 8, ["show-alert"])
  ]))
}
}

})